import React from 'react';
import { athleteDisplayName } from '../lib/billingTarget';

/**
 * "Which athlete is this for?" — shown to a guardian with several linked
 * athletes who is not currently acting as one. Takes the object returned by
 * useBillingTarget(); renders nothing when no choice is needed. Checkout
 * stays disabled until a pick exists (athleteUserId is null until then).
 */
export default function BillingAthletePicker({ target, style }) {
  if (!target) return null;
  if (target.rosterFailed) {
    return (
      <div className="ed-card" role="alert" style={{ marginBottom: 16, ...style }}>
        We couldn't load your linked athletes. Refresh the page to try again.
      </div>
    );
  }
  if (target.noLinkedAthletes) {
    return (
      <div className="ed-card" role="alert" style={{ marginBottom: 16, ...style }}>
        Link your athlete to your account before subscribing — a plan belongs to the athlete, not the parent account.
      </div>
    );
  }
  const roster = target.managedAthletes || [];
  const choosing = roster.length > 1 && (target.needsPicker || target.selectedAthleteId != null);
  if (!choosing) return null;

  return (
    <fieldset className="ed-card" data-testid="billing-athlete-picker"
      style={{ marginBottom: 16, border: '1px solid #cbd5e1', ...style }}>
      <legend style={{ fontWeight: 700, padding: '0 4px' }}>Which athlete is this for?</legend>
      {roster.map((a) => (
        <label key={a.athlete_user_id} style={{ display: 'block', padding: '6px 0', cursor: 'pointer' }}>
          <input
            type="radio"
            name="billing-athlete"
            value={a.athlete_user_id}
            checked={target.selectedAthleteId === a.athlete_user_id}
            onChange={() => target.selectAthlete(a.athlete_user_id)}
            style={{ marginRight: 8 }}
          />
          {athleteDisplayName(a)}
        </label>
      ))}
    </fieldset>
  );
}
